///////COMPONENTS///////
import { put, select, takeLatest } from 'redux-saga/effects'
import ActionsTypes from '../../constants/ActionsTypes'
import { globalLoadingActionCreators, errorManagerActionCreators, kioskEditSetupActionCreators, toastSuccessActionCreators } from '../actions'
import * as R from '../../constants/Endpoint'
import { API_TOKEN, API_TOKEN_DL_FILE } from '../../config/AxiosConfig'
import { selectIdsUser } from '../selectors/user'
import { uriList } from '../../routings/settings/RouteList'

const getKioskSetup = function* ({ payload }) {
	const user = yield select(selectIdsUser)
	const apiCall = R.GET_KIOSK_SETUP(payload.id)
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).get(apiCall)

		yield put(kioskEditSetupActionCreators.getKioskSetupSuccess(data.data))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskEditSetupActionCreators.getKioskSetupFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}
const putEditKioskSetup = function* ({ payload }) {
	const bodyMsg = payload.data
	const user = yield select(selectIdsUser)
	const apiCall = R.PUT_EDIT_KIOSK_SETUP(payload.idKiosk)
	const MsgParams = 'toast__kiosk__in__production__modify__admin_update'
	const redirectRequest = `${uriList.kiosksInProduction}${uriList.kioskProductionList}`
	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN(user.jwt).put(apiCall, bodyMsg)

		yield put(kioskEditSetupActionCreators.putEditKioskSetupSuccess(data.data))
		yield put(toastSuccessActionCreators.hydrateToast(MsgParams, redirectRequest))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))
		yield put(kioskEditSetupActionCreators.putEditKioskSetupFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const viewProductionFile = function* ({ payload }) {
	const requestId = payload.requestId

	const user = yield select(selectIdsUser)
	const bodyMsg = payload.filters
	const apiCall = R.VIEW_PRODUCTION_FILE(requestId)

	yield put(globalLoadingActionCreators.startLoading())

	try {
		const data = yield API_TOKEN_DL_FILE(user.jwt).put(apiCall, bodyMsg)

		const type = 'application/pdf'

		const url = window.URL.createObjectURL(new Blob([data.data], { type: type }))

		window.open(url, 'blank')
		yield put(kioskEditSetupActionCreators.viewProductionFileSuccess(data.data, payload.idContract))
	} catch (e) {
		yield put(errorManagerActionCreators.createError(e.response))

		yield put(kioskEditSetupActionCreators.viewProductionFileFailure(e.response))
	} finally {
		yield put(globalLoadingActionCreators.endLoading())
	}
}

const sagas = function* () {
	yield takeLatest(ActionsTypes.GET_KIOSK_SETUP, getKioskSetup)
	yield takeLatest(ActionsTypes.PUT_EDIT_KIOSK_SETUP, putEditKioskSetup)
	yield takeLatest(ActionsTypes.VIEW_PRODUCTION_FILE, viewProductionFile)
}

export default sagas
